module.exports = __webpack_public_path__ + "img/logo-f2.81d93709.png";